import React, { useCallback, useState, useMemo } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { IGroupDetailed } from '../../types/group'
import { updateGroup } from '../../actions/group'
import { AppStateType } from '../../reducers'
import { selectIsSystemApprover } from '../../selectors/auth'
import {
  createGetCapabilityApprovalStatus,
  createIsPendingApproval,
} from '../../services/capability'
import { decorateIf, matchId, notMatchId } from '../../services/common'
import { Button, TooltipedChip, Modal, P } from '../../components'

export interface IRequiredApprovalCapabilityBlock {
  id: string
  group: IGroupDetailed
  isSystemApprover: boolean
  dispatch: Dispatch
}

export const RequiredApprovalCapabilityBlockComponent = ({
  id,
  group,
  isSystemApprover,
  dispatch,
}: IRequiredApprovalCapabilityBlock) => {
  const getCapabilityApprovalStatus = useMemo(() => (
    createGetCapabilityApprovalStatus(group)
  ), [group])
  const isPendingApproval = useMemo(() => createIsPendingApproval(group), [group])
  const [isApproveDialogOpen, setIsApproveDialogOpen] = useState(false)
  const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false)
  const approveCapability = useCallback(() => {
    dispatch(
      updateGroup({
        ...group,
        capabilities: group.capabilities.map(
          decorateIf(matchId(id))({ approved: true })
        ),
      })
    )
    setIsApproveDialogOpen(false)
  }, [dispatch, id, group])
  const rejectCapability = useCallback(() => {
    dispatch(
      updateGroup({
        ...group,
        capabilities: group.capabilities.filter(notMatchId(id)),
      })
    )
    setIsRejectDialogOpen(false)
  }, [dispatch, id, group])
  return (
    <>
      {' '}
      <TooltipedChip {...getCapabilityApprovalStatus(id)} />
      {isSystemApprover && isPendingApproval(id) && (
        <>
          <Button
            type="button"
            size="small"
            color="primary"
            className="approve-capability-button"
            onClick={() => {
              setIsApproveDialogOpen(true)
            }}
          >
            Approve
          </Button>
          <Button
            type="button"
            size="small"
            color="secondary"
            className="reject-capability-button"
            onClick={() => {
              setIsRejectDialogOpen(true)
            }}
          >
            Reject
          </Button>
          <Modal
            id="group-capability-approve-modal-dialog"
            open={isApproveDialogOpen}
            handleClose={() => {
              setIsApproveDialogOpen(false)
            }}
            action={approveCapability}
            title="Approve the capability"
            actionLabel="Approve"
          >
            <P>Are you sure you want to approve the capability?</P>
          </Modal>
          <Modal
            id="group-capability-reject-modal-dialog"
            open={isRejectDialogOpen}
            handleClose={() => {
              setIsRejectDialogOpen(false)
            }}
            action={rejectCapability}
            title="Reject the capability"
            actionLabel="Reject"
          >
            <P>Are you sure you want to reject the capability?</P>
          </Modal>
        </>
      )}
    </>
  )
}

const mapStateToProps = (state: AppStateType) => ({
  isSystemApprover: selectIsSystemApprover(state),
})

export const RequiredApprovalCapabilityBlock = connect(mapStateToProps)(
  RequiredApprovalCapabilityBlockComponent
)
